async function calculateForStrings(value, weight, max, min) {
  let score = 0;
  if (weight > 0 && value !== null && value !== undefined) {
    if (value.name.toLowerCase() === max.toLowerCase()) score = 1;
    if (value.name.toLowerCase() === min.toLowerCase()) score = 0;
    score = Math.round(score * weight * 100) / 100;
  }
  return score;
}

async function calculateForIntegers(value, weight, max, min) {
  let score = 0;
  if (weight > 0 && value !== null && value !== undefined) {
    let score_percent = 0;
    if (min > max) {
      score = 1 - value / 100;
      if (max >= value) score = 1;
    } else {
      score_percent = value / max;
      score = score_percent > 1 ? 1 : score_percent;
    }
    score = Math.round(score * weight * 100) / 100;
  }
  if (score < 0) score = 0;
  return score;
}

async function calculateScore(value, question) {
  let score = 0;

  if (question.question_weight > 0 && !stringIsEmpty(value)) {
    if (question.options.length > 0) {
      score = await calculateForStrings(
        value,
        question.question_weight,
        question.score_range['max'],
        question.score_range['min']
      );
    } else {
      score = await calculateForIntegers(
        value,
        question.question_weight,
        question.score_range['max'],
        question.score_range['min']
      );
    }
  }
  return score;
}

function scoreColorStyle(score_percent, answer) {
  let result = {
    'text-danger': true,
  };
  if (!answer.value) {
    result = {
      'text-disabled': true,
    };
  }
  if (score_percent >= 0.5) {
    result = {
      'text-warning': true,
    };
  }
  if (score_percent >= 1) {
    result = {
      'text-primary': true,
    };
  }
  return result;
}

function stringIsEmpty(value) {
  if (typeof value === 'string') {
    return value ? value.trim().length === 0 : true;
  } else {
    return value === null;
  }
}

export default {
  calculateForStrings,
  calculateForIntegers,
  calculateScore,
  scoreColorStyle,
};
